import * as z from 'zod';

import { StrictAddress } from '../Address';
import { AuthorizedContactId, BorrowerId, EntityId, EscrowCompanyId, TaskId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';

export const LoanDocumentMailRecipientParty = z.discriminatedUnion('type', [
  z.object({ type: z.literal('borrower'), borrowerId: BorrowerId }),
  z.object({ type: z.literal('authorizedContact'), authorizedContactId: AuthorizedContactId }),
  z.object({ type: z.literal('escrowCompany'), escrowCompanyId: EscrowCompanyId }),
  z.object({ type: z.literal('entity'), entityId: EntityId }),
]);
export type LoanDocumentMailRecipientParty = z.infer<typeof LoanDocumentMailRecipientParty>;

export const LoanDocumentMailRecipient = z.object({
  party: LoanDocumentMailRecipientParty.optional(), // some external parties will not have a stored db record
  name: z.string(), // name + address stored for immutability
  address: StrictAddress.optional(),
});
export type LoanDocumentMailRecipient = z.infer<typeof LoanDocumentMailRecipient>;

export const LoanDocumentMailedViaApi = z.object({
  method: z.literal('mailedViaApi'),
  date: zodDateOrString,
  testMode: z.boolean().optional(),
  recipient: LoanDocumentMailRecipient.optional(),
});
export type LoanDocumentMailedViaApi = z.infer<typeof LoanDocumentMailedViaApi>;

export const LoanDocumentAddedToMailTask = z.object({
  method: z.literal('addedToMailTask'),
  date: zodDateOrString,
  taskId: TaskId,
  // Who the task was expected to mail to when it was created. Whoever completes
  // the task by hand is not required to mail to this party.
  recipient: LoanDocumentMailRecipient.optional(),
});
export type LoanDocumentAddedToMailTask = z.infer<typeof LoanDocumentAddedToMailTask>;

export const LoanDocumentMailStatus = z.discriminatedUnion('method', [
  LoanDocumentMailedViaApi,
  LoanDocumentAddedToMailTask,
]);
export type LoanDocumentMailStatus = z.infer<typeof LoanDocumentMailStatus>;
